import { render, staticRenderFns } from "./machineryServiceInfoWindow.vue?vue&type=template&id=387c6a00&scoped=true"
import script from "./machineryServiceInfoWindow.vue?vue&type=script&lang=js"
export * from "./machineryServiceInfoWindow.vue?vue&type=script&lang=js"
import style0 from "./machineryServiceInfoWindow.vue?vue&type=style&index=0&id=387c6a00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387c6a00",
  null
  
)

export default component.exports